import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { languageOptions, useLanguage } from '../i18n/LanguageContext';
import { siteContent } from '../data/siteContent';

const NavBar = () => {
    const location = useLocation();
    const { language, setLanguage } = useLanguage();
    const content = siteContent[language];
    const [isOpen, setIsOpen] = useState(false);
    const headerRef = useRef(null);

    const closeMenus = () => {
        setIsOpen(false);
        headerRef.current?.querySelectorAll('details').forEach((details) => {
            details.open = false;
        });
    };

    useEffect(() => closeMenus(), [location.pathname]);

    return (
        <header ref={headerRef} className="relative z-50 border-b border-brown-50/10 bg-brown-25/95 backdrop-blur-sm">
            <div className="mx-auto flex max-w-7xl items-center justify-between px-4 sm:px-8">
                <Link to="/home" onClick={closeMenus} aria-label="Neuroptimisme home" className="shrink-0">
                    <img src="/assets/logo.png" alt="Neuroptimisme" className="h-20 w-20 object-contain" />
                </Link>

                <button
                    type="button"
                    aria-label={isOpen ? 'Close menu' : 'Open menu'}
                    aria-expanded={isOpen}
                    className="rounded-full border border-white/50 px-4 py-2 text-white sm:hidden"
                    onClick={() => setIsOpen((open) => !open)}
                >
                    <span className="text-xl leading-none">{isOpen ? '×' : '☰'}</span>
                </button>

                <div className={`${isOpen ? 'max-h-[42rem] opacity-100' : 'max-h-0 opacity-0'} absolute left-0 right-0 top-20 overflow-hidden bg-brown-25 px-5 transition-all duration-300 sm:static sm:flex sm:max-h-none sm:items-center sm:overflow-visible sm:bg-transparent sm:px-0 sm:opacity-100`}>
                    <nav className="flex flex-col gap-1 pb-5 pt-2 sm:flex-row sm:items-center sm:gap-7 sm:pb-0 sm:pt-0" aria-label="Main navigation">
                        <Link to="/home" onClick={closeMenus} className="nav-link">{content.nav.home}</Link>
                        <details className="group relative sm:flex sm:items-center">
                            <summary className="nav-link list-none cursor-pointer">{content.nav.knowMe} <span className="text-xs">⌄</span></summary>
                            <div className="mt-1 space-y-1 pl-3 sm:absolute sm:left-0 sm:mt-4 sm:w-64 sm:rounded-2xl sm:bg-white sm:p-3 sm:pl-3 sm:shadow-xl">
                                <Link to="/qui_suis_je" onClick={closeMenus} className="nav-dropdown-link">{content.nav.aboutMe}</Link>
                                <Link to="/experiences" onClick={closeMenus} className="nav-dropdown-link">{content.nav.experiences}</Link>
                                <Link to="/parcours" onClick={closeMenus} className="nav-dropdown-link">{content.nav.journey}</Link>
                            </div>
                        </details>
                        <Link to="/a_propos" onClick={closeMenus} className="nav-link">{content.nav.approach}</Link>
                        <details className="group relative sm:flex sm:items-center">
                            <summary className="nav-link list-none cursor-pointer">{content.nav.services} <span className="text-xs">⌄</span></summary>
                            <div className="mt-1 space-y-1 pl-3 sm:absolute sm:right-0 sm:mt-4 sm:w-72 sm:rounded-2xl sm:bg-white sm:p-3 sm:pl-3 sm:shadow-xl">
                                {content.services.map((service) => (
                                    <Link key={service.key} to={service.path} onClick={closeMenus} className="nav-dropdown-link">
                                        <img src={service.icon} alt="" className="h-5 w-5 object-contain" />
                                        <span>{service.title}</span>
                                    </Link>
                                ))}
                            </div>
                        </details>
                    </nav>

                    <div className="flex items-center gap-3 border-t border-white/25 pb-5 pt-4 sm:ml-8 sm:border-0 sm:pb-0 sm:pt-0">
                        <a href={content.social.whatsapp} target="_blank" rel="noopener noreferrer" className="hidden text-xs text-white/85 transition-colors hover:text-white lg:block">
                            WhatsApp · {content.social.whatsappLabel}
                        </a>
                        <label className="flex items-center gap-2 text-xs text-white/80">
                            <span className="sr-only">{content.nav.language}</span>
                            <select value={language} onChange={(event) => setLanguage(event.target.value)} className="rounded-full border border-white/35 bg-transparent px-3 py-2 text-white outline-none">
                                {languageOptions.map((option) => <option key={option.code} value={option.code} className="text-brown-50">{option.label}</option>)}
                            </select>
                        </label>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default NavBar;
